import { render, staticRenderFns } from "./PsCalendarGridDayEvent.vue?vue&type=template&id=2d2b7bf1&scoped=true&"
import script from "./PsCalendarGridDayEvent.vue?vue&type=script&lang=js&"
export * from "./PsCalendarGridDayEvent.vue?vue&type=script&lang=js&"
import style0 from "./PsCalendarGridDayEvent.vue?vue&type=style&index=0&id=2d2b7bf1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b7bf1",
  null
  
)

export default component.exports